import { AuthUserResponse } from "./user";
import { History, LocationState } from "history";

export interface AuthenticationResponse {
    blockedUsers: string[];
    user: AuthUserResponse;
    token: string;
}

export interface RegistrationRequest {
    recaptchaToken: string;
    fullname: string;
    username: string;
    email: string;
    birthday: string;
}

export interface LoginRequest {
    email?: string | undefined;
    username?: string | undefined;
    password: string;
    history: History<LocationState>;
    recaptchaToken: string;
}
export interface ForgotPasswordRequest {
    email?: string | undefined;
    username?: string | undefined;
}

export enum RegistrationStep {
    STEP_1 = "STEP_1",
    STEP_2 = "STEP_2",
    STEP_3 = "STEP_3",
    STEP_4 = "STEP_4",
    STEP_5 = "STEP_5",
    STEP_6 = "STEP_6"
}
